<template>
    <div class="px-4 py-6">
        <div
            v-if="config.data && config.data.title"
            class="text-lg font-medium text-gray-900 mb-2"
        >
            {{ config.data.title }}
        </div>

        <div class="grid grid-cols-3 gap-[3px] -mx-4">
            <div
                v-for="(image, index) in config.data.images"
                :key="index"
                class="w-full min-h-[130px] bg-cover bg-center bg-no-repeat cursor-pointer"
                :style="{ backgroundImage: `url(${getImage(image)})` }"
                data-cy="gallery-image"
                @click="openGalleryModal(index)"
                @keydown.enter="openGalleryModal(index)"
            />
        </div>
    </div>
</template>

<script setup>

    const props = defineProps({
        config: Object,
    })

    const { openGallery } = useGallery()

    const getImage = (image) => {
        if (image.thumbnail) {
            return image.thumbnail
        }

        return image.image
    }

    const openGalleryModal = (index) => {
        openGallery({
            images: get(props.config, 'data.images'),
            start: index,
        })
    }
</script>
